import { customAxios } from '../../../common/customAxios';

interface postImageUserProfileProps {
  reqBody: {
    file: File;
  };
}

// TODO : PVM-2844 유저 프로필 이미지 업로드 리팩토링 필요 여부 판단 및 리팩토링 진행
export const postImageUserProfile = ({ reqBody }: postImageUserProfileProps): Promise<{ url: string }> => {
  return customAxios.post('/images/user-profile', reqBody, {
    headers: { 'Content-Type': 'multipart/form-data', charset: 'utf-8' },
  });
};
